import calcAge from "@/lib/calcAge";
export default function yupAgeValidate(y) {
  y.addMethod(y.string, "age", function (validAge) {
    return this.test("age", `${validAge}歳未満は登録できません。`, function (value) {
      const age = calcAge(value);
      return age >= validAge;
    });
  });
}